import { apiFetch } from '../api';

export const getAmcList = (filters) => {
  return apiFetch(`/AMCDetails/Search`, {
    method: 'POST',
    body: JSON.stringify(filters)
  });
};

export const addAMC = (payload) => {
  return apiFetch(`/AMCDetails/Write`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

export const deleteAMCAPI = (amcGUID) => {
  return apiFetch(`/AMCDetails/Delete?id=${amcGUID}`, {
    method: 'POST'
  });
};
